import { render, staticRenderFns } from "./CaseAdd.vue?vue&type=template&id=198e16a8&scoped=true&"
import script from "./CaseAdd.vue?vue&type=script&lang=js&"
export * from "./CaseAdd.vue?vue&type=script&lang=js&"
import style0 from "./CaseAdd.vue?vue&type=style&index=0&id=198e16a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e16a8",
  null
  
)

export default component.exports